import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { TabView } from "iuvity-ui-components/dist/tabview";
import { Header } from "../../components";
import { PermissionAdminComponent } from "../../components/permissions/PermissionAdminComponent";
import { usePermissions } from "../../hooks/usePermissions";

export const AdminPermissionPage = () => {
    const navigate = useNavigate();
    const {
        t,
        appState: { user, activeIndexCatalogue },
        setAppState,
    } = useContext(AppContext);

    const { data, permissionsAction, reloadFn } = usePermissions("DATA");
    const [activeIndex, setActiveIndex] = useState<number>(activeIndexCatalogue || 0);

    return (
        <>
            {/* <Header
                welcomeMessage={t("Dashboard.welcomeTitle")}
                userName={user?.name}
            /> */}
            <TransactionalSubheader
                subheaderTitle={
                    <div
                        style={{
                            position: "relative",
                            left: "-2rem",
                        }}
                    >
                        <span style={{ color: "var(--cardBackgroundColorOneShade80)" }}>
                            {t("Permissions.permissionsTitle")}
                        </span>
                    </div>
                }
            >
                <TransactionalSubheader.BreadCrumb
                    id={t("Permissions.permissionsTitle")}
                    disabledDefaultHome={true}
                    breadcrumbsHomeItem={{
                        icon: "iu iu-icon-home",
                        command: () => navigate("/"),
                    }}
                    breadcrumbsItems={[
                        {
                            label: t("ConsoleTranslations.adminConsoleMenuLabel"),
                            style: { fontWeight: "bold" },
                            disabled: true
                        },
                        {
                            label: t("Permissions.permissionsBreadcrumb"),
                            disabled: true
                        },
                    ]}
                />
                <TransactionalSubheader.Title />
            </TransactionalSubheader>

            <BoxFull className="px-5 py-0" style={{ marginTop: "40px" }} variant="tertiary">
                <div
                    className="catalogue__description"
                    style={{
                        fontFamily: "var(--fontBarlowRegular)",
                        fontSize: "var(--font-size-md)",
                        color: "var(--cardBackgroundColorOneShade80)",
                    }}
                >
                    <span>{t("Permissions.permissionsDescription")}</span>
                </div>
                <TabView
                    className="upload-tabview mt-4"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                        setAppState((prev) => ({
                            ...prev,
                            activeIndexPoints: e.index,
                        }));
                    }}
                    items={[
                        {
                            key: "1",
                            header: t("Permissions.availableTabTitle"),
                            children:
                                <PermissionAdminComponent
                                    data={data}
                                    permissionsAction={permissionsAction}
                                    reloadFn={reloadFn}
                                />,
                        },
                        {
                            key: "2",
                            header: t("Permissions.deletedTabTitle"),
                            children:
                                <PermissionAdminComponent
                                    data={data}
                                    permissionsAction={permissionsAction}
                                    reloadFn={reloadFn}
                                    isDeleteComponent
                                />,
                        },
                    ]}
                />
            </BoxFull>
        </>
    )
}